import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.push.js";
import getPx from '@/utils/getPx';
import { paperDetail, questionList, answerQuestion } from '@/api/mg';
import { logEvent } from 'firebase/analytics';
export default {
  data: function data() {
    return {
      is_finish: false,
      isSuccess: false,
      isShowOptions: true,
      title: '',
      content: '',
      message: '',
      isStart: true,
      isEnd: false,
      isShow: false,
      num: 1,
      questions: [],
      isActive: true,
      transitionName: '',
      arr: ['Hot', 'Latest'],
      activeName: 'Hot',
      options: [],
      id: '',
      gotop: false
    };
  },
  created: function created() {
    this.lineWidth = getPx(550 / this.questions.length * this.num);
    this.getPaperDetail({
      id: this.$route.query.id
    });
    // this.getQuestionList({ id: this.$route.query.id })
  },
  mounted: function mounted() {
    window.addEventListener('scroll', this.handleScroll, true);
  },
  destroyed: function destroyed() {
    // 销毁
    window.removeEventListener('scroll', this.handleScroll, true);
  },
  // beforeCreate() {
  //   document.body.classList.add('fullScreen')
  // },
  // beforeDestroy() {
  //   console.log('remove')
  //   document.body.classList.remove('fullScreen')
  // },
  computed: {
    lineWidth: {
      get: function get() {
        return getPx(550 / this.questions.length * this.num);
      },
      set: function set(val) {
        console.log(val, 'val');
      }
    }
  },
  methods: {
    // 监听滚动事件
    handleScroll: function handleScroll() {
      if (document.getElementById('backTop')) {
        var scrolltop = document.getElementById('backTop');
        if (scrolltop.scrollTop) {
          scrolltop > 30 ? this.gotop = true : this.gotop = false;
        }
      }
    },
    back: function back() {
      this.$router.back();
    },
    getQuestionList: function getQuestionList(params) {
      var _this = this;
      this.disabled = false;
      questionList(params).then(function (res) {
        if (res.Code === 0) {
          _this.options = res.Data.chapter.options;
          _this.options.forEach(function (item) {
            item.selected = false;
          });
          console.log(_this.options, 'this.options');
          _this.message = '';
          console.log(res.Data);
          var answer = res.Data.chapter.answer.answer;
          var type = res.Data.chapter.type;
          if (answer) {
            if (type === 3) {
              _this.message = answer;
              console.log(res.Data.chapter.answer, 111);
            }
            if (type === 1 || type === 2) {
              _this.options.forEach(function (item) {
                answer.forEach(function (item1) {
                  console.log(item1, 'item1');
                  if (Number(item1) === item.id) {
                    item.selected = true;
                  }
                });
              });
            }
          }
        } else {
          _this.$message.error(res.Message);
        }
      });
    },
    getPaperDetail: function getPaperDetail(params) {
      var _this2 = this;
      paperDetail(params).then(function (res) {
        if (res.Code === 0) {
          console.log(res.Data, 'res.Data');
          _this2.title = res.Data.course.title;
          _this2.is_finish = res.Data.is_finish != 0;
          _this2.content = res.Data.course.content;
          _this2.questions = res.Data.chapter;
          _this2.id = _this2.questions[_this2.num - 1].id;
          _this2.getQuestionList({
            id: _this2.id
          });
        } else {
          _this2.$message.error(res.Message);
        }
      });
    },
    last: function last() {
      if (this.num > 1) {
        this.isStart = false;
        this.isEnd = false;
        this.num--;
        this.id = this.questions[this.num - 1].id;
        this.getQuestionList({
          id: this.id
        });
      }
      if (this.num === 1) {
        this.isStart = true;
        // this.id = this.questions[this.num - 1].id
        // this.getQuestionList({ id: this.id })
      }
      // if (this.message) {
      //   this.message = ''
      // }
    },
    next: function next() {
      if (this.disabled) {
        return;
      }
      if (document.getElementById('backTop')) {
        var top = document.getElementById('backTop');
        if (top.scrollTop) {
          var _top = document.getElementById('backTop').scrollTop;
          // 定时改变高度，实现滚动效果
          var timeTop = setInterval(function () {
            document.getElementById('backTop').scrollTop = _top -= 30;
            if (_top <= 0) {
              clearInterval(timeTop);
            }
          }, 10);
        }
      }
      if (this.questions.length == this.num + 1 || this.questions.length == this.num) {
        this.isEnd = true;
      } else {
        this.isEnd = false;
      }
      if (this.questions[this.num - 1].type === 3) {
        if (!this.message.trim()) {
          this.$toast(this.$t('iinfo'));
          return;
        }
      }
      if (this.questions[this.num - 1].type === 2) {
        console.log(1);
        var arr = [];
        this.options.forEach(function (item) {
          if (item.selected) {
            arr.push(item.id);
          }
        });
        if (arr.length <= 1) {
          this.$toast(this.$t('iinfo'));
          return;
        }
      }
      if (this.questions[this.num - 1].type === 1) {
        console.log(2);
        var id;
        this.options.forEach(function (item) {
          if (item.selected) {
            id = item.id;
          }
        });
        if (!id) {
          this.$toast(this.$t('iinfo'));
          return;
        }
      }
      if (this.num === this.questions.length) {
        this.isSuccess = true;
        console.log(this.isSuccess, this.questions[this.num - 1].type === 3);
        this.isEnd = true;
        this.submit();
        // const timer = setTimeout(() => {
        //   this.$router.back()
        //   clearTimeout(timer)
        // }, 3000)
        // this.id = this.questions[this.num - 1].id
        // this.getQuestionList({ id: this.id })
      }

      if (this.num < this.questions.length) {
        this.disabled = true;
        this.submit();
        this.isStart = false;
        /* this.num=2 时已经走到最后一页了*/
        // this.isEnd = false
        this.num++;
        this.id = this.questions[this.num - 1].id;
        this.getQuestionList({
          id: this.id
        });
      }
    },
    submit: function submit() {
      var _this3 = this;
      var params;
      if (this.questions[this.num - 1].type === 3) {
        params = {
          chapter_id: this.id,
          answer: this.message
        };
      }
      if (this.questions[this.num - 1].type === 2) {
        var arr = [];
        this.options.forEach(function (item) {
          if (item.selected) {
            arr.push(item.id);
          }
        });
        params = {
          chapter_id: this.id,
          answer: arr
        };
      }
      if (this.questions[this.num - 1].type === 1) {
        var id;
        this.options.forEach(function (item) {
          if (item.selected) {
            id = item.id;
          }
        });
        params = {
          chapter_id: this.id,
          answer: id
        };
      }
      console.log(params, 22);
      answerQuestion(params).then(function (res) {
        if (res.Code === 0) {
          logEvent(_this3.$analytics, 'Club_Survey_Submit', {
            Club_Survey_Submit: '',
            Click_time: '',
            Club_Survey_Title: _this3.title
          });
        } else {
          _this3.$toast(res.Message);
        }
      });
    },
    hidePop: function hidePop() {
      this.isShow = false;
    },
    onSelect: function onSelect(index) {
      if (this.is_finish) {
        return;
      }
      this.isShowOptions = false;
      this.options.forEach(function (item) {
        item.selected = false;
      });
      this.options[index].selected = true;
      this.isShowOptions = true;
    },
    onMultipleSelect: function onMultipleSelect(index) {
      if (this.is_finish) {
        return;
      }
      this.isShowOptions = false;
      this.options[index].selected = !this.options[index].selected;
      this.isShowOptions = true;
    },
    toAnswer: function toAnswer() {
      this.isShow = true;
    }
  }
};